var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n\t.st1{opacity:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1C7.7,1,4.1,4.5,4.1,8.9v0c0,0,0,0,0,0.1V9c0,0.1,0,0.1,0,0.2c0,0.3,0.1,0.8,0.2,1.5c0,0,0,0,0,0.1l0,0.2 c0.6,3,2.2,8.5,7,11.9l0.6,0.4l0.6-0.4c4.8-3.4,6.5-8.9,7-11.9l0-0.2c0,0,0,0,0-0.1c0.1-0.7,0.2-1.2,0.2-1.5c0-0.1,0-0.1,0-0.2V9 l0-0.1C19.9,4.5,16.3,1,12,1z M17.9,9c0,0.2,0,0.5-0.1,0.9c0,0.1,0,0.3-0.1,0.4c0,0,0,0.1,0,0.1l0,0.1c-0.5,2.6-1.8,7.2-5.7,10.2 c-3.8-3-5.2-7.6-5.7-10.2v-0.2l0-0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4-0.1-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1 c0,0,0,0,0,0v0C6.2,5.6,8.8,3,12,3c3.2,0,5.9,2.6,5.9,5.8L17.9,9L17.9,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,8.9L6.1,8.9C6.1,9,6.1,8.9,6.1,8.9C6.1,8.9,6.1,8.9,6.1,8.9L6.1,8.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,10.7c-0.1-0.5-0.2-1-0.2-1.5C4.2,9.5,4.2,10,4.3,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,9C6.1,9,6.1,8.9,6.1,9L6.1,9L6.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,9.3c0-0.1,0-0.2,0-0.3C6.1,9,6.2,9.2,6.2,9.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,9.2c0,0.5-0.1,1-0.2,1.5C19.8,10,19.8,9.5,19.9,9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,12.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3S13.8,12.3,12,12.3z M12,7.3 c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7S12.9,7.3,12,7.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZones);
export default __webpack_public_path__ + "static/media/icon-zones.e57aadf36b412702e6c5b7c3ba4d8fcf.svg";
export { ForwardRef as ReactComponent };